"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GetEnviroment = GetEnviroment;
var _isNaN = _interopRequireDefault(require("lodash/isNaN"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function GetEnviroment(url) {
  let lang = 'ch';
  let env;
  if (typeof window !== 'undefined') {
    if (window.location.hostname !== 'localhost') {
      const host = window.location.host.split('.');
      if ((0, _isNaN.default)(+host[2])) {
        lang = host[2];
      }
    }
  }
  let host;
  let subdomain;
  if (typeof window !== 'undefined') {
    host = url.split('.');
    subdomain = host[0].split('-');
  } else {
    subdomain = url || ['dev'];
  }
  // setup ENV variables to be sent in the Log object
  if (subdomain.length === 2 || subdomain.length === 1 && (subdomain[0].indexOf('dev') !== -1 || subdomain[0].indexOf('stage') !== -1)) {
    if (subdomain[0] === 'dev') {
      env = 'DEV';
    } else if (subdomain[0] === 'stage') {
      env = 'STAGING';
    } else {
      env = 'PROD';
    }
  } else if (subdomain.length === 1 && subdomain[0].indexOf('localhost') === -1 && subdomain[0].indexOf('0') === -1 && subdomain[0].indexOf('192') === -1 && subdomain[0] !== 3) {
    env = 'PROD';
  } else {
    env = 'LOCAL';
  }
  return {
    env,
    lang
  };
}